import MatchHeight from "./matchHeight";

(() => {
  window.addEventListener("load", function () {
    document.body.classList.add("is-load");
    document.querySelector("main").classList.add("is-load");
  });
})();

// Design Template Swiper こっち
let dt2swiper;
const createdt2swiper = () => {
  dt2swiper = new Swiper(".js-p-top-dt2-swiper", {
    loop: true,
    slidesPerView: 1.8,
    spaceBetween: 18,
    speed: 4500, // ループの時間
    allowTouchMove: false, // スワイプ無効
    // preventInteractionOnTransition: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      480: {
        slidesPerView: 4,
        spaceBetween:18,
      },
      769: {
        slidesPerView: 3,
        spaceBetween:18,
      },
      1224: {
        speed: 6000,
        slidesPerView: 4,
        spaceBetween: 18,
      },
      1920: {
        slidesPerView: 6,
        spaceBetween: 18,
      },
    },
  });
};

createdt2swiper();

window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    dt2swiper.destroy(false, true);
    createdt2swiper();
  } else if (window.performance.navigation.type == 2) {
    dt2swiper.destroy(false, true);
    createdt2swiper();
  }
});


// Design Template　Swiper
const kvSwiper = new Swiper(".js-p-top-kv-swiper", {
  loop: true,
  effect: "fade",
  speed: 700,
  fadeEffect: {
    crossFade: true,
    // transformEl: 'img',
  },
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".js-p-top-kv-swiper-pagination",
    clickable: true,
  },
});

const handleMediaQuery = (event) => {
  if (event.matches) {
    createEsSwiper();
    createProductSwiper();
    // createInterviewSwiper();
  } else {
    destroyEsSwiper();
    destroyProductSwiper();
    // destroyInterviewSwiper();
  }
};

const mediaQuery = window.matchMedia("(max-width: 768px)");

window.addEventListener("load", () => handleMediaQuery(mediaQuery));
mediaQuery.addEventListener("change", handleMediaQuery);

const swiperEsDom = document.querySelector(".js-p-top-es-swiper");
let swiperEs;

const swiperEsOptions = {
  //add swiper options
  slidesPerView: 1.1,
  centeredSlides: true,
  pagination: {
    el: ".js-p-top-es-swiper-pagination",
    clickable: true,
  },
};

const createEsSwiper = () => {
  if (!swiperEs) swiperEs = new Swiper(swiperEsDom, swiperEsOptions);
};

const destroyEsSwiper = () => {
  if (swiperEs) {
    swiperEs.destroy(false, true);
    swiperEs = null;
  }
};

const swiperProductDom = document.querySelector(".js-p-top-product-swiper");
let swiperProduct;

const swiperProductOptions = {
  slidesPerView: 1.1,
  centeredSlides: true,
  spaceBetween: 16,
  pagination: {
    el: ".js-p-top-product-swiper-pagination",
    clickable: true,
  },
  // navigation: {
  //   nextEl: '.js-p-top-product-swiper-button-next',
  //   prevEl: '.js-p-top-product-swiper-button-prev',
  // },
};

const createProductSwiper = () => {
  if (!swiperProduct) swiperProduct = new Swiper(swiperProductDom, swiperProductOptions);
};

const destroyProductSwiper = () => {
  if (swiperProduct) {
    swiperProduct.destroy(false, true);
    swiperProduct = null;
  }
};

const swiperInterviewDom = document.querySelector(".js-p-top-interview-swiper");
let swiperInterview;

const swiperInterviewOptions = {
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 25,
  pagination: {
    el: ".js-p-top-interview-swiper-pagination",
    clickable: true,
  },
};

const createInterviewSwiper = () => {
  if (!swiperInterview) swiperInterview = new Swiper(swiperInterviewDom, swiperInterviewOptions);
};

const destroyInterviewSwiper = () => {
  if (swiperInterview) {
    swiperInterview.destroy(false, true);
    swiperInterview = null;
  }
};

matchMedia(
  () => {
    createEsSwiper();
    createProductSwiper();
    // createInterviewSwiper();
  },
  () => {
    destroyEsSwiper();
    destroyProductSwiper();
    // destroyInterviewSwiper();
  }
);

// モーダル
(() => {
  window.addEventListener("load", function () {
    let dataModal = document.querySelectorAll("[data-modal]");
    let dataModalInner = document.querySelectorAll("[data-inner]");

    (function () {
      const modalArea = document.getElementById("js-modalArea");
      const modalBg = document.getElementById("js-modalBg");
      const closeBtn = document.querySelector(".js-closeBtn");
      const toggle = [modalBg, closeBtn, ...dataModal];

      for (let i = 0, len = toggle.length; i < len; i++) {
        toggle[i].addEventListener("click", function () {
          if (!modalArea.classList.contains("is-show")) {
            modalArea.classList.add("is-show");
            if (window.innerWidth <= 768) {
              document.querySelector("html").style.overflow = "hidden";
            }
          } else {
            modalArea.classList.remove("is-show");
            document.querySelector("html").style.overflow = "initial";
          }
        });
      }

      let w = window.innerWidth;

      window.addEventListener("resize", () => {
        if (w === window.innerWidth) return;
        w = window.innerWidth;
        if (modalArea.classList.contains("is-show")) {
          modalArea.classList.remove("is-show");
          document.querySelector("html").style.overflow = "initial";
        }
      });
    })();

    let textContentEvent = (element) => {
      element.addEventListener("click", () => {
        let id = element.dataset.modal;
        dataModalInner.forEach((modalElE) => {
          let id_inner = modalElE.dataset.inner;
          modalElE.classList.remove("is-show");
          if (id === id_inner) {
            modalElE.classList.add("is-show");
          }
        });
      });
    };

    dataModal.forEach((element) => {
      textContentEvent(element);
    });
  });
})();

// アコーディオン
$(".js-accordion").click(function (e) {
  $(this).toggleClass("is-open");
  $(this).next().toggleClass("is-open").stop().slideToggle(200);
});

(() => {
// SP時の無料で始めるボタンの表示
  let element = document.querySelector(".js-p-top-es");
  let faElement = document.querySelector(".js-p-top-free-adulation");
  let targetDOMRect;
  let targetTop;

  window.addEventListener("scroll", () => {
    targetDOMRect = element.getBoundingClientRect();
    targetTop = targetDOMRect.top + window.pageYOffset;
    if (window.scrollY > targetTop) {
      faElement.classList.add("is-show");
    } else {
      faElement.classList.remove("is-show");
    }
  });

})();

// IntersectionObserver
window.addEventListener(
  "load",
  function () {
    function callback(entries) {
      for (let i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add("is-active");
        } else {
        }
      }
    }

    let options = {
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0.0,
    };

    let observer = new IntersectionObserver(callback, options);

    var dataSan = document.querySelectorAll("[data-san]");
    let observeropcity = function () {
      for (let i = 0; i < dataSan.length; i++) {
        observer.observe(dataSan[i]);
      }
    };
    observeropcity();
  },
  false
);

// gif hover
// const allowExtensions = ".(jpeg|jpg|png)$"; // 許可する拡張子

// window.addEventListener(
//   "load",
//   function () {
//     const productSwiperSlides = document.querySelectorAll(".js-p-top-product-swiper-slide");
//     productSwiperSlides.forEach((element, i) => {
//       element.addEventListener("mouseover", function () {
//         if (window.innerWidth >= 769) {
//           let imgEl = element.querySelector("img.js-p-top-product-swiper-slide-img-gif");
//           if (imgEl.src.match(allowExtensions)) {
//             imgEl.src = `/images/lp/top/product0${i + 1}.gif`;
//             imgEl.style.opacity = 1;
//           } else {
//           }
//         }
//       });
//       element.addEventListener("mouseleave", function () {
//         if (window.innerWidth >= 769) {
//           let imgEl = element.querySelector("img.js-p-top-product-swiper-slide-img-gif");
//           if (imgEl.src.match(allowExtensions)) {
//           } else {
//             imgEl.src = `/images/lp/top/product0${i + 1}.jpg`;
//             imgEl.style.opacity = 0;
//           }
//         }
//       });
//     });
//   },
//   false
// );

// 使用例
// items: 高さを揃えたい要素
// wrapper: リサイズを検知したい要素（この要素がリサイズすると、高さを揃える処理が走ります）
// let productSwiperSlideInner = new MatchHeight(".js-p-top-product-swiper-slide-inner", ".js-p-top-product-swiper-wrapper");

let priceItemTitle = new MatchHeight(".js-p-top-price-item-title", ".js-p-top-price-list");
let priceItemSubtitleWrap = new MatchHeight(".js-p-top-price-item-subtitle-wrap", ".js-p-top-price-list");
let priceItemLead = new MatchHeight(".js-p-top-price-item-lead", ".js-p-top-price-list");
let priceItemBtnWrap = new MatchHeight(".js-p-top-price-item-btn-wrap", ".js-p-top-price-list");
let priceItemInner = new MatchHeight(".js-p-top-price-item-inner", ".js-p-top-price-list");
